import React from 'react';
import { Link } from 'react-router-dom'


const IntroDom = (props) => {
  const introHtml = props && props.apply_detail ? props.apply_detail : '';
  const introZY= props && props.apply_banner ? props.apply_banner : '';
  let showType = '';
  switch(props.type) {
    case "创业课堂":
    case "垂直班":
    case "A轮班":
      showType = '课堂';break;
    case "主题游学":
    case "定制游学":
      showType = '游学';break;
    case "沙龙":
      showType = '沙龙';break;
    default:
      showType = '活动';break;
  }
  const isCourseEnd = props.date ? !!(new Date(props.date) < new Date()) : false; // 处理是否结束
  const showTimeTips = isCourseEnd ? ' (报名已结束)' : '';
  return (
    <div className="intro-content">
      <p className="intro-zy need-clear">
      { introZY }
      { 
        !props.isShowValue.intro && !props.notShow && introHtml && 
        <span>
          <Link to={`${window.location.search}&intro=show`} target="_blank"> 【查看详情】</Link>
        </span>
      }
      </p>
      {
        props.showFeeIntro && props.fee_intro &&
        <p className="fee-intro">
          { props.fee_intro }
        </p>
      }
      { 
        (!!props.class_time || !!props.city || !!props.class_size || !!props.fee) && props.is_show_class_info == 'yes' && 
        <div className="detail-info border-bottom padding-bottom-20 need-clear">
          {!!props.class_time && <p>{ showType }时间：<span>{ props.class_time }</span><label>{ showTimeTips }</label></p>}
          {!!props.city && <p>{ showType }地点：<span>{props.city}</span>{ !isCourseEnd && !props.notShowPositionTips && <label> (录取后通知具体地点)</label> }</p>}
          {!!props.class_size && <p>{ showType }人数：<span>{ props.class_size }人</span></p>}
          {!!props.fee && <p>{ showType }费用：<span>{ props.fee === '0' || props.fee === '0元' ? '免费' : props.fee }</span>{ props.fee !== '0' && props.fee !== '0元' && props.fee !== 0 && !isCourseEnd && <label> (审核录取后收取)</label> }</p>}
        </div>
      }
      { 
        introHtml && props.isShowValue.intro === 'show' &&
        <div className="intro-detail border-bottom padding-bottom-20" dangerouslySetInnerHTML={{
          __html: introHtml
        }} />
      }
    </div>
  )
}
export default IntroDom;
